import Vue from 'vue';
import * as uiv from 'uiv';
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import VueMoment from 'vue-moment';
import VueInternationalization from 'vue-i18n';
import axios from 'axios';
import ResourcePicker from '@/components/ResourcePicker';
import Spinner from '@/components/Spinner';
import PageSpinner from '@/components/PageSpinner';
import Select from '@/components/Select';
import Button from '@/components/Button';
import AbsoluteOrRelativeCurrencyToggleInputGroup from '@/components/AbsoluteOrRelativeCurrencyToggleInputGroup';
import NumericInputWithCurrencySelect from '@/components/NumericInputWithCurrencySelect';
import AccountSearchSelect from '@/components/AccountSearchSelect';
import CostableView from '@/modules/costable/view';
import VenuesView from '@/modules/venues/view';
import DocumentView from '@/modules/document/view';
import NavbarSearch from '@/components/NavbarSearch';
import ResourceVariantEditor from '@/components/ResourceVariantEditor';
import CopyInput from '@/components/CopyInput';
import DateRangeInput from '@/components/DateRangeInput';
import PurchaseOrderSuppliers from '@/components/PurchaseOrderSuppliers';
import MessageRulePatterns from '@/components/MessageRulePatterns';
import store from './store';
import EventStatusInput from '@/components/EventStatusInput';
import ImportQuoteSelect from '@/components/ImportQuoteSelect.vue';

require('./utils/event-bus');
require('./utils/sentry');
require('./plugins/froala');
require('./plugins/numeral');
require('ideal-postcodes-autocomplete');

Vue.use(uiv);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMoment);
Vue.use(VueInternationalization);

const locale = localStorage.getItem('locale') || 'en';

const i18n = new VueInternationalization({
    locale,
});

axios.get('/api/app-v1/language').then((response) => {
    i18n.setLocaleMessage(locale, response.data);
});

Vue.component('Spinner', Spinner);
Vue.component('PageSpinner', PageSpinner);
Vue.component('Select', Select);
Vue.component('Button', Button);
Vue.component('AbsoluteOrRelativeCurrencyToggleInputGroup', AbsoluteOrRelativeCurrencyToggleInputGroup);
Vue.component('NumericInputWithCurrencySelect', NumericInputWithCurrencySelect);
Vue.component('AccountSearchSelect', AccountSearchSelect);
Vue.component('navbar-search', NavbarSearch);
Vue.component('resource-picker', ResourcePicker);
Vue.component('resource-variant-editor', ResourceVariantEditor);
Vue.component('copy-input', CopyInput);
Vue.component('PurchaseOrderSuppliers', PurchaseOrderSuppliers);
Vue.component('message-rule-patterns', MessageRulePatterns);
Vue.component('date-range-input', DateRangeInput);
Vue.component('event-status-input', EventStatusInput);
Vue.component('import-quote-select', ImportQuoteSelect);

Vue.config.productionTip = false;

// eslint-disable-next-line no-new
new Vue({
    el: '#app',
    i18n,
    store,
    components: {
        'app-costable': CostableView,
        'app-venues': VenuesView,
        'app-document': DocumentView,
    },
});
